import React from "react"
import {Card} from "@irati/ui/src/Layout"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {Body, H5} from "@irati/ui/src/Typography"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import FormattedMessage from "@irati/utils/lang"
import Spacing from "@irati/ui/src/Spacing"

export const Eligibility = () => {
  const theme = useTheme()

  return (
    <Spacing marginTop={6} marginBottom={6}>
      <Card bgColor={theme.colors.primary1_50}>
        <Flex marginBottom={1.5} alignItems="center">
          <Icon icon={IconTypes.info} extraLarge color={theme.colors.primary1} block={false} />
          <H5 marginLeft={1}>
            <FormattedMessage id="platform.payrollpay.store.landing.c2w.eligible.header" />
          </H5>
        </Flex>
        <Body small maxWidth="unset">
          <FormattedMessage id="platform.payrollpay.store.landing.c2w.eligible.paragraph" />
        </Body>
      </Card>
    </Spacing>
  )
}
